var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25.685 23.868",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26313 0 0 .26313 -11.026 -259.57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m114.63 1061.1a37.795 37.795 0 0 1-61.712-29.266 37.795 37.795 0 0 1 2.3581-13.141l1.6111 4.8439 7.1727-2.3857-5.2953-15.92-16.858 0.192 0.08612 7.5586 7.5098-0.086a45.354 45.354 0 0 0-4.1433 18.938 45.354 45.354 0 0 0 74.641 34.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m61.422 997.18a45.354 45.354 0 0 1 74.641 34.631 45.354 45.354 0 0 1-4.1456 18.943l7.512-0.091 0.0861 7.5586-16.858 0.1921-5.2953-15.92 7.1727-2.3857 1.6111 4.8438a37.795 37.795 0 0 0 2.3581-13.141 37.795 37.795 0 0 0-61.714-29.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m113.84 1021.7-19.355 9.0332v24.362l19.355-9.0331z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m72.043 1015.5 18.665 8.7114 18.665-8.7114-18.665-8.7095z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m86.929 1055.1v-24.362l-19.355-9.0332v24.362z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.01184ab5c2552ff1427069d44c43499e.svg";
export { ForwardRef as ReactComponent };